import { FunctionComponent, useState, useEffect, ChangeEvent } from 'react';
import {
  SendMessageToSelf,
  EngagePostMessageActions,
  useIframeEngageActionListener,
  SendMessage,
} from '../services';
import { MenuItem } from '@mui/material';
import { OptionsMenu } from './upload-options.styles';

interface UploadOptionsProps {
  engageOrigin: string;
  jobsEnabled: boolean;
}

export const UploadOptions: FunctionComponent<UploadOptionsProps> = ({
  engageOrigin,
  jobsEnabled,
}) => {
  const eventBody = useIframeEngageActionListener({
    engageOrigin,
    action: EngagePostMessageActions.UPLOAD_OPTIONS_POPUP,
  });
  const [open, setOpen] = useState(false);
  const [contactId, setContactId] = useState('');
  const [targetPosition, setTargetPosition] = useState<null | {
    left: number;
    top: number;
  }>(null);

  const handleAddPhotos = async (e: ChangeEvent<HTMLInputElement>) => {
    const photos = Array.from(e.target.files);
    const payload = {
      REQUEST_ACTION: {
        media: photos,
        type: 'ATTACH_MEDIA_TO_MESSAGE',
        source: 'computer',
      },
    };
    SendMessage(payload, engageOrigin, true);
    handleClose();
  };

  const chooseOption = (type: string) => {
    SendMessageToSelf(
      {
        REQUEST_ACTION: {
          type,
          associationId: contactId,
          associationType: 'contact',
        },
      },
      true
    );
    handleClose();
  };

  useEffect(() => {
    setOpen(eventBody != null);

    if (eventBody) {
      setContactId(eventBody.contactId);
      setTargetPosition(eventBody.targetPosition);
    }
  }, [eventBody]);

  const handleClose = () => {
    setOpen(false);
    setContactId('');
  };

  function UploadFromJobMenuItem() {
    if (jobsEnabled) {
      return (
        <MenuItem
          data-e2e="upload-photo-from-job"
          onClick={() =>
            chooseOption(EngagePostMessageActions.OPEN_SELECT_JOB_MODAL)
          }
        >
          Upload photo from Job
        </MenuItem>
      );
    }

    return null;
  }

  return (
    <div>
      <OptionsMenu
        id="upload-options-menu"
        data-e2e="upload-options-menu"
        open={open}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={targetPosition}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <MenuItem
          data-e2e="upload-photo-from-contact"
          onClick={() =>
            chooseOption(EngagePostMessageActions.OPEN_ATTACH_FILE_DIALOG)
          }
        >
          Upload photo from Contact
        </MenuItem>
        <UploadFromJobMenuItem></UploadFromJobMenuItem>
        <MenuItem data-e2e="upload-photo-from-files">
          <label>
            Upload from files
            <input
              type="file"
              accept="image/jpeg, image/png"
              hidden
              onChange={handleAddPhotos}
            />
          </label>
        </MenuItem>
      </OptionsMenu>
    </div>
  );
};
